import { RiskLevelEnum, RiskLevelScoreEnum, DetectionRiskLevelScoreEnum } from '@/constants/risk-level.constants'

export function getHostTrailRiskLevel (riskScore) {
  if (riskScore === RiskLevelScoreEnum.ZERO) {
    return {
      level: RiskLevelEnum.ZERO,
      label: RiskLevelEnum.properties[RiskLevelEnum.ZERO].title
    }
  } else if (riskScore < RiskLevelScoreEnum.LOW) {
    return {
      level: RiskLevelEnum.LOW,
      label: RiskLevelEnum.properties[RiskLevelEnum.LOW].title
    }
  } else if (riskScore < RiskLevelScoreEnum.MEDIUM) {
    return {
      level: RiskLevelEnum.MEDIUM,
      label: RiskLevelEnum.properties[RiskLevelEnum.MEDIUM].title
    }
  } else {
    return {
      level: RiskLevelEnum.HIGH,
      label: RiskLevelEnum.properties[RiskLevelEnum.HIGH].title
    }
  }
}

export function getDetectionRiskLevel (riskScore) {
  if (riskScore === DetectionRiskLevelScoreEnum.ZERO) {
    return {
      level: RiskLevelEnum.ZERO,
      label: RiskLevelEnum.properties[RiskLevelEnum.ZERO].title
    }
  } else if (riskScore <= DetectionRiskLevelScoreEnum.LOW) {
    return {
      level: RiskLevelEnum.LOW,
      label: RiskLevelEnum.properties[RiskLevelEnum.LOW].title
    }
  } else if (riskScore <= DetectionRiskLevelScoreEnum.MEDIUM) {
    return {
      level: RiskLevelEnum.MEDIUM,
      label: RiskLevelEnum.properties[RiskLevelEnum.MEDIUM].title
    }
  } else {
    return {
      level: RiskLevelEnum.HIGH,
      label: RiskLevelEnum.properties[RiskLevelEnum.HIGH].title
    }
  }
}

export function runningScoreContribution (scoreContributions, property) {
  let scoreHistory = []
  for (let i = 0; i < scoreContributions.length; i++) {
    if (i === 0) {
      scoreHistory.push(scoreContributions[i].scoreContribution)
    } else {
      if (!scoreContributions[i].scoreContribution) {
        scoreContributions[i].scoreContribution = 0
      }
      scoreHistory.push(scoreHistory[i - 1] + scoreContributions[i].scoreContribution)
    }
  }

  return scoreHistory
}



// WEBPACK FOOTER //
// ./src/utilities/riskscore.js